import React, { useState } from 'react';
import './VideoBackground.css';

const VideoBackground = () => {
  const [videoError, setVideoError] = useState(false);

  const handleVideoError = () => {
    setVideoError(true);
    console.error('Error loading video background');
  };

  return (
    <div className="video-background">
      {!videoError ? (
        <video
          autoPlay
          loop
          muted
          playsInline
          className="video-background__video"
          onError={handleVideoError}
        >
          <source src={`${process.env.PUBLIC_URL}/videos/background.mp4`} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      ) : (
        <div className="video-background__fallback">
          Video background failed to load
        </div>
      )}
      <div className="video-background__overlay"></div>
    </div>
  );
};

export default VideoBackground; 